class PropertyModel {
  constructor(data) {
    this.id = data.PropertyID || null;
    this.siteId = data.SiteID || null;
    this.fullAddress = data.FullAddress || null;
    this.siteName = data.SiteName || null;
    this.postCode = data.Postcode || null;
    this.territoryId = data.TerritoryID || null;
    this.territoryName = data.TerritoryName || null;
    this.customerId = data.ClientID || null;
    this.customerName = data.ClientName || null;
    this.redFlag = Boolean(data.RedFlag);
    this.propertyAccessNotes = data.PropertyAccessNotes || "";
    this.siteAccessNotes = data.SiteAccessNotes || null;
    this.accessNotes = data.AccessNotes || [];
  }
}

export default PropertyModel;
